// src/features/auth/api/authApi.ts
import { get, post } from '@/common/services/httpClient';
import type { AuthResponse, ForgotPasswordInputs, VerifyPolicyHolderInputs, LoginFormInputs, ResetPasswordInputs, ValidateTokenResponse } from '../types/authTypes';

export const loginUser = async (credentials: LoginFormInputs): Promise<AuthResponse> => {
  const response = await post<AuthResponse>('/Auth/Login', credentials);
 
  return { ...response, menus: response.menus };
};


interface ApiResponse {
  [key: string]: unknown; // Generic type for API response
}

export const fetchData = async (): Promise<ApiResponse> => {
  try {
    const response = await get<ApiResponse>('/data');
    return response;
  } catch (error: unknown) {
    console.error('Error fetching data from API:', error);
    throw error; // Re-throw the error to be handled by the calling component
  }
};

export const forgotPassword = async (data: ForgotPasswordInputs) => {
  const response = await post('/auth/forgot-password', data);
  return response; // you added this, right?
};

export const resetPassword = async (data: ResetPasswordInputs): Promise<void> => {
  await post('/auth/reset-password', data);
};

export const validateResetToken = async (token: string): Promise<ValidateTokenResponse> => {
    const response = await get<ValidateTokenResponse>(`/auth/activate-account?token=${token}`);
    return response;
};

export const verifyPolicyHolder = async (data: VerifyPolicyHolderInputs) => {
    const response = await post('/auth/verify-policyholder', data);
    return response; // you added this, right?
};

export const setPassword = async (data: ResetPasswordInputs) => {
    const response = await post('/auth/set-password', data);
    return response;
};


export const verifyOTP = async (data: VerifyPolicyHolderInputs) => {
    const response = await post('/auth/verify-otp', data);

    return response; 
};


// export const fetchUserProfile = async (): Promise<UserProfile> => {
//   const response = await get<UserProfile>('/Auth/profile');
//   return response;
// };

// export const updateProfile = async (profileData: Partial<UserProfile>): Promise<UserProfile> => {
//   const response = await put<UserProfile>('/Auth/profile', profileData);
//   return response;
// };